import React from 'react';

import { useSelector } from 'react-redux';

import dynamic from 'next/dynamic';

import { useFeatures } from '@atc/features';
import { ClientOnly } from '@atc/react-client-only';

import activeInteractionDuck from '@/ducks/activeInteractionDuck.js';
import srpActiveInteractionDuck from '@/ducks/srp/srpActiveInteractionDuck.js';

const CompareListingsContainer = dynamic(() => import(
    /* webpackChunkName: "CompareListingsContainer" */
    '@/containers/CompareListingsContainer'
), { ssr: false });
const ShareListingsContainer = dynamic(() => import(
    /* webpackChunkName: "ShareListingsContainer" */
    '@/containers/ShareListingsContainer'
), { ssr: false });
const ShareListingContainer = dynamic(() => import(
    /* webpackChunkName: "ShareListingContainer" */
    '@/containers/srp/ShareListingContainer'
), { ssr: false });
const ReportAtcListing = dynamic(() => import(
    /* webpackChunkName: "ReportAtcListing" */
    '@/components/ReportAtcListing/index.js'
), { ssr: false });
const SearchResultsEmailModalContainer = dynamic(() => import(
    /* webpackChunkName: "SearchResultsEmailModalContainer" */
    '@/containers/srp/SearchResultsEmailModalContainer'
), { ssr: false });
const KeywordSearchContainer = dynamic(() => import(
    /* webpackChunkName: "KeywordSearchModalContainer" */
    '@/containers/KeywordSearchModalContainer'
    , { ssr: false }
));

function SearchResultsPageModals() {

    const {
        advanced_keyword_search: [enableAdvancedKeywordSearch],
        compare: [showCompare],
        my_atc_shareable_link: [enableSharableLink],
        my_wallet: [enableMyWallet],
    } = useFeatures([
        'advanced_keyword_search',
        'compare',
        'my_atc_shareable_link',
        'my_wallet',
    ]);

    const showEmailModal = useSelector(srpActiveInteractionDuck.selectors.getShowEmailModal);
    const showCompareModal = useSelector(srpActiveInteractionDuck.selectors.getShowCompareModal);
    const isShareModalActive = useSelector(srpActiveInteractionDuck.selectors.getShowShareListingModal);
    const isReportListingModalActive = useSelector(srpActiveInteractionDuck.selectors.getShowReportModal);
    const showKeyWordSearchModal = useSelector(activeInteractionDuck.selectors.getShowKeywordSearchModal);

    return (
        <>
            {enableMyWallet && showCompare && showCompareModal && (
                <ClientOnly>
                    <CompareListingsContainer />
                </ClientOnly>
            )}

            {enableSharableLink && (
                <ClientOnly>
                    <ShareListingsContainer />
                </ClientOnly>
            )}

            {isShareModalActive && (
                <ClientOnly>
                    <ShareListingContainer />
                </ClientOnly>
            )}

            {isReportListingModalActive && (
                <ClientOnly>
                    <ReportAtcListing />
                </ClientOnly>
            )}

            {showEmailModal && <SearchResultsEmailModalContainer />}

            {(enableAdvancedKeywordSearch && showKeyWordSearchModal) && (
                <KeywordSearchContainer />
            )}
        </>
    );
}

export default SearchResultsPageModals;
